import {Card, Spin, Typography} from "antd";
import React, {useEffect, useState} from "react";
import ResultCellHighlight from "../components/table/ResultCellHighlight";
import Plural from "../components/Plural";
import EmptyLine from "./outputs/EmptyLine";
import ResultText from "./outputs/ResultText";
import _ from 'lodash'
import ResultHeader from "../components/table/ResultHeader";
import ResultRow from "../components/table/ResultRow";
import ResultHeaderCell from "../components/table/ResultHeaderCell";
import ResultBody from "../components/table/ResultBody";
import ResultBodyCell from "../components/table/ResultBodyCell";
import ResultTable from "../components/table/ResultTable";
import HecRasHelper from "../helpers/HecRasHelper";

export default function CompareSummaryPanel({report, summary, plan, wsel, filter}) {
    const fontFamily = report ? 'Calibri' : 'Segoe ui'
    const fontSize = report ? '11pt' : '9pt'

    if(report) {
        return (
            <>
                {getDetail({summary, fontFamily, fontSize, planTitle: plan?.base?.type})}
                {renderCalculationTolTable({summary, fontFamily, fontSize, planTitle: plan?.base?.type})}
                {renderWSEL(wsel, filter, fontFamily, fontSize)}
            </>
        )
    }

    return (
        <div style={{backgroundColor: 'white', padding: 8, height: '100%'}}>
            {getDetail({summary: summary, fontFamily, fontSize, planTitle: plan?.type})}
            <EmptyLine height={16}/>
            {renderCalculationTolTable({summary: summary, fontFamily, fontSize, planTitle: plan?.type})}
            <EmptyLine height={16}/>
            {renderWSEL(wsel, filter, fontFamily, fontSize)}
        </div>
    )
}

const renderCalculationTolTable = ({summary, planTitle}) => {
    return (
        <>
            <ResultText>
                {_.isEqual(summary?.base?.calculation_tolerances, summary?.compare?.calculation_tolerances) ? 'HEC-RAS calculation tolerances of the plans are identical.' : 'HEC-RAS calculation tolerances of the plans are different.'}
                <EmptyLine/>
            </ResultText>
            <ResultTable maxWidth={HecRasHelper.getWidth(70)}>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell colSpan={3}>
                            HEC-RAS Calculation Tolerances
                        </ResultHeaderCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultHeaderCell style={{width: HecRasHelper.getWidth(40), textAlign: 'left'}}>Calculation</ResultHeaderCell>
                        <ResultHeaderCell style={{width: HecRasHelper.getWidth(15), textAlign: 'right'}}>{planTitle?.base || 'Base Plan'}</ResultHeaderCell>
                        <ResultHeaderCell style={{width: HecRasHelper.getWidth(15), textAlign: 'right'}}>{planTitle?.compare || 'Comparison Plan'}</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left'}}>Water surface calculation tol.</ResultHeaderCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{summary?.base?.calculation_tolerances?.StdStepTol}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(summary?.base?.calculation_tolerances?.StdStepTol, summary?.compare?.calculation_tolerances?.StdStepTol)}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left'}}>Critical depth calculation tol.</ResultHeaderCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{summary?.base?.calculation_tolerances?.CriticalTol}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(summary?.base?.calculation_tolerances?.CriticalTol, summary?.compare?.calculation_tolerances?.CriticalTol)}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left'}}>Maximum number of iterations</ResultHeaderCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{summary?.base?.calculation_tolerances?.NumOfStdStepTrials}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(summary?.base?.calculation_tolerances?.NumOfStdStepTrials, summary?.compare?.calculation_tolerances?.NumOfStdStepTrials)}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left'}}>Maximum difference tolerance</ResultHeaderCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{summary?.base?.calculation_tolerances?.MaxErrorTol}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(summary?.base?.calculation_tolerances?.MaxErrorTol, summary?.compare?.calculation_tolerances?.MaxErrorTol)}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left'}}>Flow tolerance factor</ResultHeaderCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{summary?.base?.calculation_tolerances?.FlowTolRatio}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(summary?.base?.calculation_tolerances?.FlowTolRatio, summary?.compare?.calculation_tolerances?.FlowTolRatio)}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left'}}>Maximum iteration in Split flow</ResultHeaderCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{summary?.base?.calculation_tolerances?.SplitFlowNTrial}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(summary?.base?.calculation_tolerances?.SplitFlowNTrial, summary?.compare?.calculation_tolerances?.SplitFlowNTrial)}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left'}}>Flow tolerance factor in weir split flow</ResultHeaderCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{summary?.base?.calculation_tolerances?.SplitFlowRatio}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(summary?.base?.calculation_tolerances?.SplitFlowRatio, summary?.compare?.calculation_tolerances?.SplitFlowRatio)}</ResultBodyCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'left'}}>Max difference in junction split flow</ResultHeaderCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{summary?.base?.calculation_tolerances?.SplitFlowTol}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(summary?.base?.calculation_tolerances?.SplitFlowTol, summary?.compare?.calculation_tolerances?.SplitFlowTol)}</ResultBodyCell>
                    </ResultRow>
                </ResultBody>
            </ResultTable>
        </>
    )
}

const getDetail = ({summary, fontFamily, fontSize, planTitle}) => {

    return (
        <div>
            <table style={{fontFamily: fontFamily, fontSize: fontSize}}>
                <tr>
                    <td style={{verticalAlign: 'top'}}>
                        {
                            summary.base && (
                                <div>
                                    <Typography.Text style={{fontSize: '9pt', fontFamily: fontFamily, fontWeight: 'bold'}}>
                                        {planTitle?.base || 'Base' }{' '}Plan
                                    </Typography.Text>
                                    <br/>
                                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                        <span>{summary.base?.length} feet ({(summary.base?.length/5280).toFixed(2)} miles) reach</span>
                                        {summary.base?.spatial_xy && summary.base.spatial_xy.length === 2 && (
                                            <span>Spatial Identifier<span style={{marginLeft: 16}}>({summary.base.spatial_xy[0]}, {summary.base.spatial_xy[1]})</span></span>
                                        )}
                                    </div>
                                    <Plural
                                        count={summary.base?.crossSections}
                                        singular={'cross section'}
                                        plural={'cross sections'}
                                        render={(count, text) => (
                                            <>
                                                {count} {text}
                                            </>
                                        )}
                                    />
                                    <Plural
                                        count={summary.base.single_bridge}
                                        singular={'(single opening) bridge'}
                                        plural={'(single opening) bridges'}
                                        render={(count, text) => {
                                            return (
                                                <>
                                                    <br />
                                                    {count} {text}
                                                </>
                                            )
                                        }}
                                    />
                                    <Plural
                                        count={summary.base.multiple_bridge}
                                        singular={'multiple openings'}
                                        plural={'multiple openings'}
                                        render={(count, text) => {
                                            return (
                                                <>
                                                    <br />
                                                    {count} {text}
                                                </>
                                            )
                                        }}
                                    />
                                    <Plural
                                        count={summary.base?.culverts}
                                        singular={'culvert'}
                                        plural={'culverts'}
                                        render={(count, text) => {
                                            return (
                                                <>
                                                    <br />
                                                    {count} {text}
                                                </>
                                            )
                                        }}
                                    />
                                    <Plural
                                        count={summary.base?.inline}
                                        singular={'inline structure'}
                                        plural={'inline structures'}
                                        render={(count, text) => {
                                            return (
                                                <>
                                                    <br/>
                                                    {count} {text}
                                                </>
                                            )
                                        }}
                                    />
                                    <Plural
                                        count={summary.base?.profiles}
                                        singular={'profile'}
                                        plural={'profiles'}
                                        render={(count, text) => (
                                            <>
                                                <br />
                                                {count} {text}
                                                <Plural
                                                    count={summary.base?.flowLocations}
                                                    singular={'location'}
                                                    plural={'locations'}
                                                    render={(count, text) => {
                                                        return ` with ${count} flow change ${text}`
                                                    }}
                                                />
                                            </>
                                        )}
                                    />
                                </div>
                            )
                        }
                    </td>
                    <td>
                        <div style={{width: 32}}></div>
                    </td>
                    <td style={{verticalAlign: 'top'}}>
                        {
                            summary.compare && (
                                <div>
                                    <Typography.Text style={{fontSize: '9pt', fontFamily: fontFamily, fontWeight: 'bold'}}>
                                        {planTitle?.compare || 'Comparison' }{' '}Plan
                                    </Typography.Text>
                                    <br/>
                                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                        <span>{(ResultCellHighlight(summary.base?.length, summary.compare?.length))} feet ({(summary.compare?.length/5280).toFixed(2)} miles) reach</span>
                                        {summary.compare?.spatial_xy && summary.compare.spatial_xy.length === 2 && (
                                            <span>Spatial Identifier<span style={{marginLeft: 16}}>({summary.compare.spatial_xy[0]}, {summary.compare.spatial_xy[1]})</span></span>
                                        )}
                                    </div>
                                    <Plural
                                        count={summary.compare?.crossSections}
                                        singular={'cross section'}
                                        plural={'cross sections'}
                                        render={(count, text) => (
                                            <>
                                                <br/>
                                                {ResultCellHighlight(summary.base?.crossSections, count)} {text}
                                            </>
                                        )}
                                    />
                                    <Plural
                                        count={summary.compare.single_bridge}
                                        singular={'(single opening) bridge'}
                                        plural={'(single opening) bridges'}
                                        render={(count, text) => {
                                            return (
                                                <>
                                                    <br/>
                                                    {ResultCellHighlight(summary.base?.single_bridge, count)} {text}
                                                </>
                                            )
                                        }}
                                    />
                                    <Plural
                                        count={summary.compare.multiple_bridge}
                                        singular={'multiple openings'}
                                        plural={'multiple openings'}
                                        render={(count, text) => {
                                            return (
                                                <>
                                                    <br/>
                                                    {ResultCellHighlight(summary.base?.multiple_bridge, count)} {text}
                                                </>
                                            )
                                        }}
                                    />
                                    <Plural
                                        count={summary.compare?.culverts}
                                        singular={'culvert'}
                                        plural={'culverts'}
                                        render={(count, text) => {
                                            return (
                                                <>
                                                    <br/>
                                                    {ResultCellHighlight(summary.base?.culverts, count)} {text}
                                                </>
                                            )
                                        }}
                                    />
                                    <Plural
                                        count={summary.compare?.inline}
                                        singular={'inline structure'}
                                        plural={'inline structures'}
                                        render={(count, text) => {
                                            return (
                                                <>
                                                    <br/>
                                                    {ResultCellHighlight(summary.compare?.inline, count)} {text}
                                                </>
                                            )
                                        }}
                                    />
                                    <Plural
                                        count={summary.compare?.profiles}
                                        singular={'profile'}
                                        plural={'profiles'}
                                        render={(count, text) => (
                                            <>
                                                <br/>
                                                {ResultCellHighlight(summary.base?.profiles, count)} {text}
                                                <Plural
                                                    count={summary.base?.flowLocations}
                                                    singular={'location'}
                                                    plural={'locations'}
                                                    render={(count, text) => (
                                                        <>
                                                            {' '} with {ResultCellHighlight(summary.base?.flowLocations, count)} flow change {text}
                                                        </>
                                                    )}
                                                />
                                            </>
                                        )}
                                    />
                                </div>
                            )
                        }
                    </td>
                </tr>
            </table>
        </div>
    )
}

const renderWSEL = (wsel, filter, fontFamily, fontSize,) => {

    let hasLimit = false
    if(
        parseFloat(wsel.revised_reach_min) === parseFloat(wsel.minCS)
        || parseFloat(wsel.revised_reach_max) === parseFloat(wsel.maxCS)
        || parseFloat(wsel.affected_reach_min) === parseFloat(wsel.minCS)
        || parseFloat(wsel.affected_reach_max) === parseFloat(wsel.maxCS)
        || parseFloat(wsel.project_min) === parseFloat(wsel.minCS)
        || parseFloat(wsel.project_max) === parseFloat(wsel.maxCS)
        || parseFloat(filter?.ds) === parseFloat(wsel.minCS)
        || parseFloat(filter?.us) === parseFloat(wsel.maxCS)
    ) {
        hasLimit = true
    }

    const toLimitStr = (cs) => {
        if(parseFloat(cs) === wsel.minCS || parseFloat(cs) === wsel.maxCS)
            return (
                <>
                    {parseFloat(cs)}<sup>(1)</sup>
                </>
            )

        return cs
    }

    const renderRevised = () => {
        if(wsel.revised_reach_min === -1 && wsel.revised_reach_max === -1)
            return (<div>Geometry is identical!</div>)

        if(wsel.revised_reach_min === 0 && wsel.revised_reach_max === 0)
            return (<div>[DS - US]</div>)

        if(wsel.revised_reach_min > 0 || wsel.revised_reach_max > 0)
        {
            return (<div>[{toLimitStr(wsel.revised_reach_min)} - {toLimitStr(wsel.revised_reach_max)}]</div>)
        }
    }

    const renderAffected = () => {
        if(wsel.affected_reach_min === -1 && wsel.affected_reach_max === -1)
            return (<div>100yr WSEL profile is identical!</div>)

        if(wsel.affected_reach_min === 0 && wsel.affected_reach_max === 0)
            return (<div>[DS - US]</div>)

        return (<div>[{toLimitStr(wsel.affected_reach_min)} - {toLimitStr(wsel.affected_reach_max)}]</div>)
    }

    const renderProjectArea = () => {
        if(
            wsel.project_min === -1
            && wsel.project_max === -1
        )
            return 'Two plans are identical!'

        if(
            wsel.project_min === 0
            && wsel.project_max === 0
        )
            return '[DS - US]'

        return (
            <>
                <div>
                    [{ResultCellHighlight(toLimitStr(filter?.ds || wsel.project_min), toLimitStr(wsel.project_min))}
                    {' '}-{' '}
                    {ResultCellHighlight(toLimitStr(filter?.us || wsel.project_max), toLimitStr(wsel.project_max))}]
                </div>
            </>
        )
    }

    let topics = _.groupBy(wsel?.topics?.filter(x => parseFloat(x.name) < parseFloat(filter?.ds) || parseFloat(x.name) > parseFloat(filter?.us)), function(b) { return b.name})

    return (
        <>
            <table style={{fontFamily: fontFamily, fontSize: fontSize}}>
                <tr>
                    <td style={{fontWeight: 'bold', width: 200}}>
                        Revised (Geometry) Reach:
                    </td>
                    <td>
                        {renderRevised()}
                    </td>
                </tr>
                <tr>
                    <td style={{fontWeight: 'bold'}}>
                        Affected Reach:
                    </td>
                    <td>
                        {renderAffected()}
                    </td>
                </tr>

                <tr>
                    <td style={{fontWeight: 'bold'}}>
                        Identified Project Reach:
                    </td>
                    <td>
                        <div>
                            {renderProjectArea()}
                        </div>
                    </td>
                    <td style={{width: 50}}>

                    </td>
                    <td style={{fontWeight: 'bold', width: 115}}>
                        Bounding XS:
                    </td>
                    <td>
                        {
                            wsel.boundary_min > -1 ? (
                                <span>
                                    ({toLimitStr(wsel.boundary_min)} - {toLimitStr(wsel.boundary_max)})
                                </span>
                            ) : (<span>None</span>)
                        }
                    </td>
                </tr>
                {
                    filter && (filter?.us?.value || filter?.ds?.value) && (
                        <>
                            <tr>
                                <td colSpan={4}></td>
                            </tr>
                            <tr>
                                <td style={{fontWeight: 'bold'}}>
                                    Selected Project Reach:
                                </td>
                                <td>
                                    [{toLimitStr(filter?.ds?.value)} - {toLimitStr(filter?.us?.value)}]
                                </td>
                            </tr>
                        </>
                    )
                }
            </table>
            <EmptyLine />
            {
                hasLimit && (
                    <div style={{fontSize: fontSize, fontFamily: fontFamily}}>
                        <sup>(1)</sup> US/DS limit of the model.
                    </div>
                )
            }
            <EmptyLine />
            <ResultText>
                {
                    (toLimitStr(filter?.ds) !== toLimitStr(wsel.project_min) || toLimitStr(filter?.us) !== toLimitStr(wsel.project_max)) && Object.keys(topics).length > 0 && (
                        <>
                            <table style={{fontFamily: fontFamily, fontSize: fontSize}}>
                                <tbody>
                                <tr>
                                    <td style={{verticalAlign: 'top', width: 50, color: 'red'}}>
                                        PRJ-00
                                    </td>
                                    <td>
                                        <span style={{color: 'red'}}>
                                            Identified Project Reach is different than the Selected Project Reach at the following {topics?.length} cross sections!
                                        </span>
                                        <EmptyLine />
                                        {Object.keys(topics).map(key => {
                                            let val = new Set(topics[key].map(x => x.title))
                                            val = Array.from(val)
                                            return `${key} (${val.join(', ')})`
                                        }).join(', ')}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </>
                    )
                }
            </ResultText>
        </>
    )
}